(ns frontend.ux-overhaul.nev.oppo.configuration
  (:require
   [common.localization :as loc]))
(def home-section
  {:nev-section/id     "home"
   :nev-section/title  "Home"
   :nev-section/type   :nev-section.type/oppo-info
   :nev-section/blocks [{:nev-block/type :nev-block.type/oppo-info}]})


(def activity-section
  {:nev-section/id     "activity"
   :nev-section/title  "Activity"
   :nev-section/type   :nev-section.type/oppo-activity
   :nev-section/blocks [{:nev-block/type :nev-block.type/activity}]})

(def landscape-section
  {:nev-section/id     "landscape"
   :nev-section/title  "Landscape"
   :nev-section/type   :nev-section.type/oppo-landscape
   :nev-section/blocks [{:nev-block/type :nev-block.type/associations}]})


(def tasks-section
  {:nev-section/id     "tasks"
   :nev-section/title  "Tasks"
   :nev-section/type   :nev-section.type/oppo-tasks
   :nev-section/blocks [{:nev-block/type :nev-block.type/tasks}]})

(def documents-section
  {:nev-section/id     "documents"
   :nev-section/title  "Documents"
   :nev-section/type   :nev-section.type/documents
   :nev-section/blocks []})

(def transactions-section
  {:nev-section/id     "transactions"
   :nev-section/title  (loc/tr :transaction-process/transactions)
   :nev-section/type   :nev-section.type/oppo-transactions
   :nev-section/blocks []})

(def fees-section
  {:nev-section/id     "fees"
   :nev-section/title  "Fees"
   :nev-section/blocks []})



(def default-view
  {:db/id            "default-oppo-view-id"
   :view/name        "Default Oppo NEV"
   :view/type        :view.type/nev
   :view/entity-type :entity.type/oppo
   :configuration    {:header   {:nev-header/type :nev-header.type/default}
                      :sections [home-section
                                 transactions-section
                                 activity-section
                                 landscape-section
                                 tasks-section
                                 documents-section]
                      :blocks   []}})
